module.exports = __webpack_public_path__ + "img/clipboard_user_outline.6fa7b75.svg";